import { Controller } from "@hotwired/stimulus"

// Development-only convenience on the login form: keeps the last username around
// so a local sign-in is one password away. The value can't live in a per-user
// preference — the login form is precisely where there is no user yet — and the
// server never acts on it; the view only wires this up in development.
//
// A cookie rather than localStorage, because localStorage is partitioned per
// origin and the port is part of an origin: a second checkout served on :3001
// would not see what :3000 remembered. Cookies ignore the port, so ticking the
// box once covers every port on localhost.
const COOKIE_NAME = "cup_remember_username"
const ONE_YEAR_IN_SECONDS = 365 * 24 * 60 * 60

export default class extends Controller {
  static targets = ["email", "checkbox"]

  connect() {
    const remembered = this.#read()
    if (remembered === null) return

    this.checkboxTarget.checked = true
    this.emailTarget.value = remembered
  }

  save() {
    if (!this.checkboxTarget.checked) return

    this.#write(encodeURIComponent(this.emailTarget.value), ONE_YEAR_IN_SECONDS)
  }

  // Clearing the checkbox only forgets the stored value — the field keeps
  // whatever is in it, because wiping input the user is halfway through typing
  // is the very cost this control exists to remove. The next visit starts empty
  // by itself.
  toggle() {
    if (this.checkboxTarget.checked) {
      this.save()
    } else {
      this.#write("", 0)
    }
  }

  #read() {
    const entry = document.cookie
      .split("; ")
      .find((candidate) => candidate.startsWith(`${COOKIE_NAME}=`))
    if (entry === undefined) return null

    return decodeURIComponent(entry.slice(COOKIE_NAME.length + 1))
  }

  #write(value, maxAge) {
    document.cookie = `${COOKIE_NAME}=${value}; path=/; max-age=${maxAge}; SameSite=Lax`
  }
}
